import { z } from "zod";

export const serverResponse = z.object({
  id: z.string(),
  apiKey: z.string(),
  orgId: z.string(),
  roomId: z.string(),
});
